import { z } from "zod";
export var TokenScope = /*#__PURE__*/ function(TokenScope) {
    TokenScope["Public"] = "public";
    // Signed auth token
    TokenScope["PaywallPreview"] = "paywall_preview";
    TokenScope["UserImpersonation"] = "user_impersonation";
    // Application authentication token
    TokenScope["LocalizationUpdate"] = "localization_update";
    TokenScope["IntegrationsRevenueCat"] = "integrations_revenue_cat";
    TokenScope["IntegrationsAppStoreConnect"] = "integrations_app_store_connect";
    return TokenScope;
}({});
export const paywallPreviewScope = z.object({
    scope: z.literal("paywall_preview"),
    applicationId: z.number(),
    // We are also going to include a few special props to include a specific
    // paywall version
    v4Paywall: z.object({
        type: z.literal("snapshot"),
        storageKey: z.string(),
        paywallId: z.number()
    }).optional()
});
export const publicScope = z.object({
    scope: z.literal("public"),
    applicationId: z.number()
});
export const revenueCatIntegrationScope = z.object({
    scope: z.literal("integrations_revenue_cat"),
    applicationId: z.number()
});
export const userScope = z.object({
    scope: z.literal("user_impersonation"),
    // Not currently enforced
    applicationId: z.number()
});
export const localizationUpdateScope = z.object({
    scope: z.literal("localization_update"),
    applicationId: z.number()
});
export const appStoreConnectIntegrationScope = z.object({
    scope: z.literal("integrations_app_store_connect"),
    applicationId: z.number()
});
// Eventually will add more
export const tokenScope = z.discriminatedUnion("scope", [
    publicScope,
    paywallPreviewScope,
    revenueCatIntegrationScope,
    userScope,
    localizationUpdateScope,
    appStoreConnectIntegrationScope
]);
export const signedAuthTokenSchema = z.object({
    // userId: z.number(),
    // orgId: z.number(),
    // roles: z.array(z.union([z.nativeEnum(GlobalRole), z.nativeEnum(MembershipRole)])),
    scopes: z.array(tokenScope)
});
